import request from '@/utils/request'
/**
 * 添加
 * @param {*} params
 */
export function add(params) {
    return request({
        url: '/bsSkillsType/save',
        method: 'post',
        data: params
    })
}
/**
 * 修改
 * @param {*} params
 */
export function edit(params) {
    return request({
        url: '/bsSkillsType/update',
        method: 'put',
        data: params
    })
}
/**
 * 通过id删除
 */
export function del(id) {
    return request({
        url: `/bsSkillsType/delete/${id}`,
        method: 'delete',
    })
}
/**
 * 查看详情
 */
export function getInfoById(id) {
    return request({
        url: `/bsSkillsType/${id}`,
        method: 'get'
    })
}